import { Environment } from '../../config/environment';
import { AssetType } from '../../api/models/Shared.types';
import { Backend } from '../../api/Backend';

export class RecommendationsUrlBuilder {
  static vodOthersLikedUrl(backend: Backend, type: AssetType | string, assetId: string): string {
    const tp = encodeURIComponent(this.toType(type));
    const aId = encodeURIComponent(assetId);
    const plt = encodeURIComponent(Environment.system);
    return backend.makeUrl(
      `srs/v2/recommendations/vod/othersliked/${tp}/${aId}?platform=${plt}` +
        '&page=${page}&catalogId=${catalogId}&extraData=${extraData}'
    );
  }

  static vodSimilarUrl(backend: Backend, type: AssetType | string, assetId: string): string {
    const tp = encodeURIComponent(this.toType(type));
    const aId = encodeURIComponent(assetId);
    const plt = encodeURIComponent(Environment.system);
    return backend.makeUrl(
      `srs/v2/recommendations/vod/similar/${tp}/${aId}?platform=${plt}` +
        '&page=${page}&catalogId=${catalogId}&extraData=${extraData}'
    );
  }

  static epgOthersLikedUrl(backend: Backend, type: AssetType | string, assetId: string) {
    const tp = encodeURIComponent(this.toType(type));
    const aId = encodeURIComponent(assetId);
    const plt = encodeURIComponent(Environment.system);
    return backend.makeUrl(
      `srs/v2/recommendations/epg/othersliked/${tp}/${aId}?platform=${plt}&focusType=ANY` +
        '&page=${page}&catalogId=${catalogId}&extraData=${extraData}'
    );
  }

  static epgSimilarUrl(backend: Backend, type: AssetType | string, assetId: string) {
    const tp = encodeURIComponent(this.toType(type));
    const aId = encodeURIComponent(assetId);
    return backend.makeUrl(
      `srs/v2/recommendations/epg/similar/${tp}/${aId}` +
        '?platform=${platformType}&focusType=ANY&page=${page}&catalogId=${catalogId}&extraData=${extraData}'
    );
  }

  static bundleContentUrl(backend: Backend, bundleId: string) {
    const platformType = encodeURIComponent(Environment.system);
    return backend.makeUrl(
      `vod/v5/cms/bundle/${bundleId}/asset?platformType=${platformType}` +
        '&page=${page}&catalogId=${catalogId}&adult=${adult}&extraData=${extraData}'
    );
  }

  static toType(type: AssetType | string) {
    if (type === AssetType.VOD || type === 'ASSET') return 'ASSET';
    else return type;
  }
}
